export default "__VITE_ASSET__XhQ89xYy__"